export default __webpack_public_path__ + "static/media/portrait7.79b6fc06.jpeg";